import { all, call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { accessTokenSelector } from "../../auth/selectors/token";
import MetricsService from "../services/Metrics.service";
import {
  FETCH_COMPANY_CONFIG_REQUEST,
  fetchCompanyConfigSuccess,
  fetchCompanyConfigFailure,
  UPDATE_COMPANY_CONFIG_REQUEST,
  updateCompanyConfigSuccess,
  updateCompanyConfigFailure,
} from "../actions/dashboards";

export function* fetchCompanyConfigSaga(action) {
  const { companyId } = action.payload;
  try {
    const service = new MetricsService();
    const token = yield select(accessTokenSelector);
    const data = yield call([service, service.getCompanyConfig], { companyId, token });
    yield put(fetchCompanyConfigSuccess(data));
  } catch (error) {
    yield put(fetchCompanyConfigFailure(error));
  }
}

export function* updateCompanyConfigSaga(action) {
  const { companyId, patch } = action.payload;
  try {
    const service = new MetricsService();
    const token = yield select(accessTokenSelector);
    const data = yield call([service, service.updateCompanyConfig], { companyId, patch, token });
    yield put(updateCompanyConfigSuccess(data));
  } catch (error) {
    yield put(updateCompanyConfigFailure(error));
  }
}

export default function* watchCompanyConfig() {
  yield all([
    takeLeading(FETCH_COMPANY_CONFIG_REQUEST, fetchCompanyConfigSaga),
    takeLatest(UPDATE_COMPANY_CONFIG_REQUEST, updateCompanyConfigSaga),
  ]);
}
